// 利用規約本文データ（/terms-of-service で表示）
export const termsOfServiceMeta = {
  label: 'Terms of Service',
  title: ['利用規約'],
  lead: [
    [
      'この利用規約（以下「本規約」といいます。）は、株式会社SALT2（以下「当社」といいます。）が提供する' +
        'コンテンツ管理・配信サービス（以下「本サービス」といいます。）の利用条件を定めるものです。',
    ],
  ],
};

export const termsOfServiceArticles = [
  {
    no: '第1条',
    title: '適用',
    body: [
      {
        list: [
          '本規約は、本サービスの利用に関する当社と利用者との間の一切の関係に適用されます。',
          '当社が本サービスに関して別途定めるガイドライン、運用ルールその他の定めは、本規約の一部を構成します。',
          '本規約と前項の定めが矛盾する場合、当該定めに特段の記載がない限り、本規約が優先します。',
        ],
      },
    ],
  },
  {
    no: '第2条',
    title: '本サービスの内容',
    body: [
      '本サービスは、当社または利用者が制作し、または適法に利用する権限を有する動画、画像、音声、文章その他のコンテンツを、当社または利用者が管理する外部サービスへアップロード、配信または公開するための機能を提供します。',
      '本サービスの具体的な機能、提供範囲および利用方法は、当社が別途定めます。',
    ],
  },
  {
    no: '第3条',
    title: '利用資格',
    body: [
      {
        list: [
          '本サービスを利用できる者は、当社が利用を認めた役員、従業員、業務委託先その他の関係者に限ります。',
          '利用者は、連携対象となる外部サービスのアカウントを操作し、コンテンツをアップロード、配信または公開する正当な権限を有していなければなりません。',
          '当社は、利用者が前各項の条件を満たさないと判断した場合、本サービスの利用を認めないことがあります。',
        ],
      },
    ],
  },
  {
    no: '第4条',
    title: 'アカウントおよび認証情報の管理',
    body: [
      {
        list: [
          '利用者は、自己の責任において、本サービスおよび連携先となる外部サービスのアカウント、パスワード、アクセストークンその他の認証情報を適切に管理するものとします。',
          '利用者は、認証情報を第三者に譲渡、貸与、共有または開示してはなりません。ただし、当社が業務上必要と認めた方法による場合を除きます。',
          '認証情報の不正使用または漏えいのおそれを認識した場合、利用者は直ちに当社へ報告し、当社の指示に従うものとします。',
        ],
      },
    ],
  },
  {
    no: '第5条',
    title: '外部サービスとの連携',
    body: [
      {
        list: [
          '利用者は、外部サービスが提供する認証画面において、連携対象のアカウントおよび許可する権限を確認した上で、連携を承認するものとします。',
          '利用者は、誤ったアカウントを連携した場合、速やかに連携を解除し、当社へ報告するものとします。',
          '外部サービスとの連携には、当該外部サービスが定める利用規約、プライバシーポリシー、ガイドラインその他の規定が適用されます。',
        ],
      },
    ],
  },
  {
    no: '第6条',
    title: 'コンテンツの確認および権利',
    body: [
      {
        list: [
          '利用者は、外部サービスへ送信する前に、コンテンツ、配信先、タイトル、説明文、公開設定、配信日時その他の配信内容を確認するものとします。',
          '利用者は、配信するコンテンツについて、必要な著作権、肖像権、商標権、音楽の利用権その他一切の権利または許諾を有していることを保証するものとします。',
          '利用者が本サービスへ登録または配信するコンテンツの権利は、利用者または当該コンテンツの正当な権利者に帰属します。',
        ],
      },
    ],
  },
  {
    no: '第7条',
    title: '禁止事項',
    body: [
      '利用者は、本サービスの利用にあたり、以下の行為を行ってはなりません。',
      {
        list: [
          '法令または公序良俗に違反する行為',
          '犯罪行為に関連する行為',
          '当社または第三者の著作権、肖像権、プライバシー、商標権その他の権利を侵害する行為',
          '権限を有しない外部サービスのアカウントを連携または操作する行為',
          '虚偽、誤認、差別、嫌がらせその他不適切な内容を含むコンテンツを配信する行為',
          '認証情報を第三者へ開示し、または不正に利用する行為',
          '本サービスまたは外部サービスのサーバー、ネットワークその他の機能を妨害する行為',
          '不正アクセスまたはその試み',
          '本サービスまたは外部サービスの制限、審査、技術的保護措置またはセキュリティ機能を回避する行為',
          '反社会的勢力に対して直接または間接に利益を供与する行為',
          'その他、当社が不適切と判断する行為',
        ],
      },
    ],
  },
  {
    no: '第8条',
    title: '本サービスの提供停止等',
    body: [
      '当社は、以下のいずれかに該当する場合、利用者への事前通知なく、本サービスの全部または一部を停止または中断できるものとします。',
      {
        list: [
          'システムの保守、点検または更新を行う場合',
          '通信回線、サーバーまたは外部サービスに障害が発生した場合',
          '地震、火災、停電、天災その他の不可抗力により、本サービスの提供が困難となった場合',
          'セキュリティ上の問題が確認された場合',
          '外部サービスのAPI、仕様、利用条件または提供方針が変更された場合',
          'その他、当社が停止または中断を必要と判断した場合',
        ],
      },
    ],
  },
  {
    no: '第9条',
    title: '利用制限および利用停止',
    body: [
      '当社は、利用者が以下のいずれかに該当する場合、事前通知なく、本サービスの全部もしくは一部の利用を制限し、または外部サービスとの連携を解除できるものとします。',
      {
        list: [
          '本規約に違反した場合',
          '登録または申告内容に虚偽があることが判明した場合',
          '認証情報の不正使用または漏えいが確認された場合',
          '当社からの連絡または指示に合理的な期間内に対応しない場合',
          'その他、当社が本サービスの利用を適切でないと判断した場合',
        ],
      },
    ],
  },
  {
    no: '第10条',
    title: '知的財産権',
    body: [
      '本サービスに関するプログラム、画面、文章、ロゴ、デザインその他の知的財産権は、当社または正当な権利者に帰属します。',
      '本規約は、利用者に対し、本サービスに関する知的財産権を譲渡または許諾するものではありません。ただし、本サービスの利用に必要な範囲を除きます。',
    ],
  },
  {
    no: '第11条',
    title: '外部サービス',
    body: [
      {
        list: [
          '本サービスは、第三者が提供する外部サービスと連携します。',
          '外部サービス上でのコンテンツの審査、公開、制限、削除、表示範囲その他の取扱いは、当該外部サービスの判断およびシステムに従います。',
          '当社は、外部サービスの仕様変更、障害、利用制限、アカウント上の措置その他当社の管理が及ばない事由について、その結果を保証しません。',
        ],
      },
    ],
  },
  {
    no: '第12条',
    title: '保証の否認および免責',
    body: [
      {
        list: [
          '当社は、本サービスについて、継続的に利用できること、指定した日時に処理が完了すること、すべてのコンテンツが外部サービス上で公開されること、または障害、エラーもしくは権利侵害が生じないことを保証しません。',
          '当社の故意または重大な過失による場合を除き、本サービスの利用または利用不能によって利用者に生じた損害について、当社は責任を負いません。',
          '当社は、本サービスに関連して利用者と第三者との間に生じた紛争について、当社の責めに帰すべき事由がある場合を除き、責任を負いません。',
        ],
      },
    ],
  },
  {
    no: '第13条',
    title: 'サービス内容の変更または終了',
    body: [
      '当社は、本サービスの内容を変更、追加または終了する場合があります。この場合、当社は、合理的な方法により事前に通知します。ただし、緊急性がある場合または軽微な変更の場合は、この限りではありません。',
    ],
  },
  {
    no: '第14条',
    title: '本規約の変更',
    body: [
      {
        list: [
          '当社は、変更が利用者の一般の利益に適合する場合、または本サービスの目的に反せず、変更の必要性および内容が合理的である場合、本規約を変更できるものとします。',
          '当社は、本規約を変更する場合、変更内容および効力発生日を、当社ウェブサイト、本サービス上の表示その他合理的な方法により事前に通知します。',
        ],
      },
    ],
  },
  {
    no: '第15条',
    title: '情報の取扱い',
    body: ['当社は、本サービスの利用に伴い取り扱う情報を、当社が別途定めるプライバシーポリシーに従い適切に取り扱います。'],
  },
  {
    no: '第16条',
    title: '権利義務の譲渡禁止',
    body: ['利用者は、当社の事前の承諾なく、本サービスの利用上の地位または本規約に基づく権利もしくは義務を第三者に譲渡し、承継させ、または担保に供してはなりません。'],
  },
  {
    no: '第17条',
    title: '準拠法および管轄',
    body: [
      {
        list: [
          '本規約の解釈および適用には、日本法を準拠法とします。',
          '本サービスまたは本規約に関して紛争が生じた場合、当社の本店所在地を管轄する地方裁判所を第一審の専属的合意管轄裁判所とします。',
        ],
      },
    ],
  },
];

export const termsOfServiceContact = {
  intro: '本規約に関するお問い合わせは、以下の窓口までお願いいたします。',
  operator: '株式会社SALT2',
  representative: '代表取締役　鬼澤 輔',
  address: '〒106-0041 東京都港区麻布台1丁目8-10 麻布偕成ビル3階',
  email: 'info@salt-2.com', // 問い合わせ窓口の共通アドレス（2026-10-18 代表指示。代表個人のアドレスは載せない）
  website: 'https://salt-2.com/',
};

export const termsOfServiceEstablishedDate = '2026年8月17日';
